"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[625],{

/***/ 8949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ProductsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useToast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1930);
/* harmony import */ var hooks_useSiteSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1371);
/* harmony import */ var hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9863);
/* harmony import */ var hooks_useBag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(760);







const ProductsList = (param)=>{
    let { children , ...props } = param;
    var ref;
    const { ProductsList: ProductsListTheme  } = (0,hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_5__/* .useComponentsTheme */ .U)();
    const { storeSettings  } = (0,hooks_useSiteSettings__WEBPACK_IMPORTED_MODULE_4__/* .useSiteSettings */ .h)();
    const { openToast  } = (0,hooks_useToast__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .p)();
    const observer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { addProductInCart , cart  } = (0,hooks_useBag__WEBPACK_IMPORTED_MODULE_6__/* .useBag */ .c)();
    const handleClickProduct = (product)=>{
        router.push("/produtos/".concat(product.tag));
    };
    const handleClickAddCart = (product, quantity)=>{
        try {
            addProductInCart(product, quantity);
        } catch (e) {
            openToast("Ops, houve um erro ao adicionar o produto no carrinho.");
        }
    };
    const quantityInBag = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((product)=>{
        const productInCart = cart === null || cart === void 0 ? void 0 : cart.items.find((item)=>{
            var ref;
            return ((ref = item.product) === null || ref === void 0 ? void 0 : ref._id) === product._id;
        });
        return (productInCart === null || productInCart === void 0 ? void 0 : productInCart.quantity) || 0;
    }, [
        cart
    ]);
    const lastProductElementRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((node)=>{
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting && props.hasMore) {
                props.setPage((prevPage)=>prevPage + 1);
            }
        });
        if (node) observer.current.observe(node);
    }, [
        props.hasMore,
        props.setPage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductsListTheme, {
        ...props,
        onClickProduct: handleClickProduct,
        onClickAddCart: handleClickAddCart,
        quantityInBag: quantityInBag,
        informQuantityAtProductCard: storeSettings === null || storeSettings === void 0 ? void 0 : (ref = storeSettings.theme) === null || ref === void 0 ? void 0 : ref.informQuantityAtProductCard,
        lastProductRef: lastProductElementRef,
        children: children
    });
};


/***/ }),

/***/ 5625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_ProductsList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8949);
/* harmony import */ var components_Body__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3405);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3869);
/* harmony import */ var _SectionTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5036);





const SimpleListProducts = (param)=>{
    let { showcase  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Body__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .u, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .SectionWrapper */ .U, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionTitle__WEBPACK_IMPORTED_MODULE_4__/* .SectionTitle */ .N, {
                    title: showcase.title,
                    href: showcase.url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductsList__WEBPACK_IMPORTED_MODULE_1__/* .ProductsList */ .R, {
                    products: showcase.products
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SimpleListProducts);


/***/ })

}]);